//@flow
import { DispatchType } from "../../global/types/redux";
import Properties from "../../../Properties";
import { LicenceNode } from "../types/GraphQlNodes";
import { graphQLInit } from "../../global/types/constants";
import { TimelapseTwoTone } from "@material-ui/icons";
import util from "util";
import { SET_COMPANY_GROUP_LICENCES } from "../../global/actions/actionNames";
const root = Properties.api_root;

type BasicInfoType = {};

export const fetchGroupLicences =
  (companyType: "DISTRIBUTER" | "RESELLER" | "ENDUSER" | "TOPLEVEL") =>
  async (dispatch: DispatchType) => {
    const BasicInfoNode = `
    id
    name
    uuid
    companyType
  `;

    const CompanyNode = `
    ${BasicInfoNode}
    licences{
      edges{
        node {
          ${LicenceNode}
        }
      }
    }
  `;

    const ChildrenNode = `
    children {
      edges {
        node {
          ${CompanyNode}
          
        }
      }
    }
  `;

    const ResellerChildrenNode = `
      ${ChildrenNode}
    `;

    const DistributerChildrenNode = `
      children {
        edges {
          node {
            ${CompanyNode}
            ${ResellerChildrenNode}
          }
        }
      }
    `;

    const AdminChildrenNode = ` 
      children {
        edges {
          node {
            ${CompanyNode}
            ${DistributerChildrenNode}
          }
        }
      }
    `;

    let childNode: string = "";
    switch (companyType) {
      case "DISTRIBUTER":
        childNode = DistributerChildrenNode;
        break;
      case "RESELLER":
        childNode = ResellerChildrenNode;
        break;
      case "TOPLEVEL":
        childNode = AdminChildrenNode;
        break;
      default:
        childNode = "";
    }

    const companyGraph = `
   {
      company {
      ${CompanyNode}
      ${childNode}
    }
  }
  `;

    let res = await fetch(
      `${root}/api/v2/company/graphql`,
      graphQLInit(companyGraph)
    );
    let json = await res.json();

    dispatch({
      type: SET_COMPANY_GROUP_LICENCES,
      company: json.data.company
    });
  };
